import React, { useEffect } from 'react';

import { useFormik } from 'formik';

import {
  getUserContact,
  updateUserContact,
  userContact,
  userLocation,
  setLocation,
  IContact,
  userActions,
} from '@pharmaplan/common';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { ContactValidator } from '../../FormValidation';
import ProfileForm from '../../ProfileForm';
import { ICommonProfile } from '../General/General';
import useDisableProfileSave from '../../../../hooks/useDisableProfileSave';

const Contacts = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const contactsInfo = useAppSelector(userContact);
  const location = useAppSelector(userLocation);

  const { longitude, latitude } = location ?? {};
  const { latitude: contactsInfoLatitude, longitude: contactsInfoLongitude } = contactsInfo ?? {};

  const handleSubmit = (values: IContact) => {
    const { address } = values ?? {};

    dispatch(
      updateUserContact({
        ...values,
        latitude,
        longitude,
        address,
      }),
    );
  };

  const formik = useFormik({
    initialValues: contactsInfo,
    onSubmit: handleSubmit,
    enableReinitialize: true,
    validationSchema: ContactValidator(),
  });

  useEffect(() => {
    dispatch(getUserContact());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(
      setLocation({
        latitude: contactsInfoLatitude,
        longitude: contactsInfoLongitude,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactsInfoLatitude, contactsInfoLongitude]);

  const { disabled } = useDisableProfileSave({
    action: userActions.contactUpdate,
    mutableValues: formik.values,
    initialValue: contactsInfo,
  });

  return (
    <ProfileForm
      setSelected={setSelected}
      disableSave={disabled}
      selected="contacts"
      formik={formik}
    />
  );
};

export default Contacts;
